// extracted by mini-css-extract-plugin
module.exports = {"plansContainer":"SubscriptionPlansContainer_plansContainer__FXPz8"};